export default "__VITE_ASSET__DSwDeOEV__"